import { render } from "./MarketingIcon.vue?vue&type=template&id=b3926e06&scoped=true"
import script from "./MarketingIcon.vue?vue&type=script&lang=js"
export * from "./MarketingIcon.vue?vue&type=script&lang=js"

import "./MarketingIcon.vue?vue&type=style&index=0&id=b3926e06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3926e06"]])

export default __exports__